// extracted by mini-css-extract-plugin
export default {"thin":"awoyxZ"};